@if (activeFilters.length > 0 && useForm) {
    <div class="filter-chips-container">
        @for (key of activeFilters; track key) {
            <div class="filter-chip">
                <span>
                    @if (key === 'search') {
                        Search: "{{ form.value[key] }}"
                    } @else if (key === 'period') {
                        {{
                            displayMonthYear
                                ? displayMonthYear
                                : form.value[key]
                        }}
                    } @else {
                        {{ form.value[key] }}
                    }
                </span>
                <button class="close-icon" (click)="onRemove(key)">✕</button>
            </div>
        }

        <button class="clear-all" *ngIf="showClearAll" (click)="onClear()">
            {{ 'clearAllFilters' | translate }}
        </button>
    </div>
} @else {
    @if (noFormFilters.length > 0 && !useForm) {
        <div class="filter-chips-container">
            @for (key of noFormFilters; track key) {
                <div class="filter-chip">
                    <span>
                        {{ this.labels[key] }}
                    </span>
                    <button class="close-icon" (click)="onRemove(key)">
                        ✕
                    </button>
                </div>
            }

            <button class="clear-all" *ngIf="showClearAll" (click)="onClear()">
                {{ 'clearAllFilters' | translate }}
            </button>
        </div>
    }
}
